module.exports = __webpack_public_path__ + "img/people-carry-box.ceebf6d5.svg";